// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"ccdf2388","5544":"cfc1c3a6"}[chunkId] + ".chunk.css";
};